<div class="app-container" *ngIf="!isMobile && loadPage">
  <div class="menu-container">
    <custom-icon
      [iconName]="menuIcon"
      [width]="48"
      [height]="48"
      colorClass="tertiary-icon-color"
      (click)="openMenu()"
    ></custom-icon>
    <div *ngIf="isMenuOpen" class="menu">
      <ul>
        <a href="https://www.vip.travelx.ai/about" target="_blank">
          <li class="font16 font600">
            {{ "app.about" | translate }}
          </li>
        </a>
        <a href="https://www.vip.travelx.ai/contact" target="_blank">
          <li class="font16 font600">
            {{ "app.contact_us" | translate }}
          </li>
        </a>
        <a href="https://www.vip.travelx.ai/privacy-policy" target="_blank">
          <li class="font16 font600">
            {{ "app.privacy_policy" | translate }}
          </li>
        </a>
        <a
          href="https://www.travelvip.ai/termsandconditions"
          target="_blank"
        >
          <li class="font16 font600">
            {{ "app.terms_and_conditions" | translate }}
          </li>
        </a>
      </ul>
    </div>
  </div>
  <div class="web-content-container">
    <div class="logo-container">
      <img class="partner-logo" [src]="selectedPartnerLogo" />
    </div>
    <div class="web-content">
      <div class="text-container">
        <h1 class="title">
          <span class="l1-title">{{
            "app.travel_like_a_star" | translate
          }}</span>
          {{ "app.experience_the_World_in_Style" | translate }}
        </h1>
        <p class="description">
          {{
            "app.powering_exceptional_airport_experiences_for_Global_Travellers"
              | translate
          }}
        </p>
        <div *ngIf="!isdropDownDisabled || isdropDownDisabled === 'false'">
          <select
            *ngIf="partner?.[1]?.clientList.length !== 0"
            [ngClass]="
              !this.theme.getClient || this.theme.getPartner?.hideInDropdown
                ? 'partner-select default-select'
                : 'partner-select'
            "
            (change)="selectClient($event)"
            [value]="selectedPartner"
          >
            <option
              [selected]="selectedPartner === partner?.[1].clientName"
              [value]="partner?.[1].clientName"
            >
              Select Company
            </option>
            <ng-container *ngFor="let item of partner?.[1]?.clientList">
              <option
                *ngIf="!item.hideInDropdown"
                [value]="item.clientName"
                [selected]="item.clientName === selectedPartner"
              >
                {{ item.clientFullName }}
              </option>
            </ng-container>
          </select>
        </div>
      </div>
    </div>
  </div>
  <div class="app">
    <div class="app-wrapper">
      <div class="transparent-bg"></div>
      <ion-app
        id="app-direction"
        [ngClass]="language === 'ar' ? 'app-direction-rtl' : ''"
        [ngStyle]="{
          width: isMobile ? '100%' : '404px',
          height: isMobile ? '100vh' : 'auto',
          'max-height': !isMobile ? '740px' : '',
          'max-width': isMobile ? 'none' : '520px',
          'border-radius': isMobile ? '0' : '54px',
          overflow: 'hidden'
        }"
      >
        <div *ngIf="isInitialLoading" class="initial-loader">
          <ion-spinner name="crescent"></ion-spinner>
        </div>
        <ng-container *ngIf="!isInitialLoading">
          <app-inline-generic-error
            style="width: 100%; height: 100%"
            *ngIf="hasError; else routerTemplate"
          ></app-inline-generic-error>
          <ng-template #routerTemplate>
            <ion-router-outlet></ion-router-outlet>
          </ng-template>
        </ng-container>
      </ion-app>
    </div>
  </div>
</div>
<ion-app
  *ngIf="isMobile"
  id="app-direction"
  [ngClass]="language === 'ar' ? 'app-direction-rtl' : ''"
>
  <div *ngIf="isInitialLoading" class="initial-loader">
    <ion-spinner name="crescent"></ion-spinner>
  </div>
  <ng-container *ngIf="!isInitialLoading">
    <app-inline-generic-error
      style="width: 100%; height: 100%"
      *ngIf="hasError; else routerTemplate"
    ></app-inline-generic-error>
    <ng-template #routerTemplate>
      <ion-router-outlet></ion-router-outlet>
    </ng-template>
  </ng-container>
</ion-app>
